import * as React from 'react';

import FileThreeD32 from './FileThreeD32';

export const fileThreeD32 = () => <FileThreeD32 />;

export default {
    title: 'Icon/Content/FileThreeD32',
    component: FileThreeD32,
    parameters: {
        notes: "`import FileThreeD32 from 'box-ui-elements/es/icon/content/FileThreeD32';`",
    },
};
